
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"68","height":"68","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#132F3D","cx":"34","cy":"34","r":"34"}}),_c('g',{attrs:{"fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M48.619 29.28c-2.196-1.325-3.626-3.175-4.844-6.076-.453-1.078-1.476-1.737-2.607-1.678-1.215.063-2.286.898-2.937 2.288a6.276 6.276 0 00-.606 2.452c-.82-1.313-2.356-1.521-3.027-.522 0 0-6.167-4.155-8.265-5.471-2.788-1.747-6.24.53-6.038 2.685-3.491-1.645-7.05 1.768-5.725 5.08-1.326-.169-4.504 3.455-.834 5.918-2.433.377-3.184 4.22-.25 5.797 0 0 .04.524.091.78-1.844.661-2.306 4.202-.436 5.215 0 0 13.5 7.578 18.129 9.828 2.515 1.222 6.751 1.532 10.437.13 3.621-.564 6.61-2.637 8.913-6.173 6.34-9.73.439-18.78-2.001-20.253m-1.527 18.744c-2.618 3.675-6.377 4.056-9.253 4.056-4.695 0-7.564-2.25-7.564-2.25L17.39 40.216c-2.44-1.683-.97-4.365.74-4.316l10.252 6.981 1.262.079s-9.156-6.57-12.12-8.882c-1.732-1.35-1.163-3.927 1.078-4.44l12.82 9.198 1.261.078L18.987 28.3c-2.893-2.114.01-6.099 2.816-4.07 3.235 2.341 12.968 9.759 12.968 9.759l1.262.08L23.22 23.46c-.111-1.636 2.067-3.06 3.81-1.757 3.502 2.618 14.015 10.465 14.015 10.465-.27-.757-.406-1.327-.406-1.327s-1.998-3.319-.916-5.735c.95-2.119 2.873-1.775 3.26-.636 1.03 3.032 2.098 4.831 4.232 6.348 2.726 1.936 5.514 9.293-.123 17.206M41.852 12.061c-1.044-1.216-2.068-1.876-3.074-1.98-1.005-.103-2.03.345-3.073 1.346l2.097 8.746 4.05-8.112zM46.937 13.755l-3.123 7.272 7.285-1.95c.73-1.701.73-3.017 0-3.95-.73-.932-2.116-1.39-4.162-1.372z"}}),_c('path',{attrs:{"d":"M29.766 12.532c-1.785-.48-2.969-.48-3.55 0-.582.48-.876 1.701-.883 3.662l6.384 4.157-1.951-7.82z"}})])])])
          )
        }
      }
    